<script setup lang="ts">
import { User } from "lucide-vue-next";
import DialogProvider from "@/ui-plus/dialog/DialogProvider.vue";
import { Toaster } from "@/ui-plus/sonner";
import OrdersHomeView from "@deliveryteam-spa-orders-vue/pages/OrdersHomeView.vue";
import { authState } from '@/ui-plus/useAuth';
import Button from '@/components/ui/button/Button.vue';
import { useColorMode } from "@vueuse/core";
import { computed } from "vue";
import { initiateRedirectLogin } from '@/ui-plus/auth/auth.pkce.redirect';

const mode = useColorMode();
const toasterTheme = computed(() => {
  if (mode.value === "auto") {
    return "system";
  } else {
    return mode.value;
  }
});

</script>

<template>
  <template v-if="authState.accessTokenPayload !== null">
    <OrdersHomeView />
  </template>
  <template v-else>
    <div class="flex flex-col items-center justify-center h-screen">
      <h1 class="text-2xl font-bold">Login with MyOrderID to see your orders</h1>
      <br>
      <Button class="mr-2"
              @click="initiateRedirectLogin('ask')">
        <User :stroke-width="3"
              class="h-8 w-8" /> Continue with MyOrderID
      </Button>
    </div>
  </template>
  <DialogProvider />
  <Toaster :theme="toasterTheme"
           closeButton
           richColors
           class="pointer-events-auto" />
</template>
